import { MarkerZIndex } from './mapConstants';

export interface GetMarkerZIndexArgs {
  isSelected: boolean;
  hasHiddenIcon?: boolean;
}

export default function getMarkerZIndex({
  isSelected,
  hasHiddenIcon,
}: GetMarkerZIndexArgs): number {
  if (isSelected) {
    return MarkerZIndex.selected;
  }
  if (hasHiddenIcon) {
    return MarkerZIndex.minimized;
  }
  return MarkerZIndex.default;
}
